import React from 'react';
import { PlannerBundlePage } from './pages/PlannerBundlePage';
export function App() {
  return <PlannerBundlePage data-id="element-0" />;
}